module.exports = __webpack_public_path__ + "media/images/home/testimonials/dale-dc2ef67cc626af466e620fd5ebdcb8dc.jpg";